import React from "react";

function Header() {
  return (
    <header className="header">
      <h1>emoji interpreter</h1>
    </header>
  );
}
export default Header;
